<template>
    <!-- Profile Drawer -->
    <div id="profile-drawer" class="chatroom-user-profile-drawer" :class="(isOpen) ? 'open' : null" >
        <div class="user-profile-drawer-wrapper" v-if="userProfile">
            <div class="user-profile-drawer-header">
                <p>{{ $t('screener.chatroom.user.chat.profile.text') }}</p>
                <label for="profile-toggle-checkbox" class="close-profile-drawer" @click="$emit('closeDrawer')">
                    <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </a>
                </label>
    
            </div>
            <div class="user-profile-drawer-content">
                <div class="profile-image-block">
                    <template v-if="userProfile.onlineStatus">
                        <span class="profile-status"></span>
                    </template>
                    <img :src="profileImage" alt="Profile Image">
                </div>
                <div class="profile-meta">
                    <p>{{ userProfile.name }}</p>
                    <a href="javascript:void(0)">
                        <button class="message" @click="$emit('selectForChat')" >{{ $t('screener.chatroom.user.chat.message.text') }}</button>
                    </a>
                </div>
                <div class="profile-info">
                    <p><span>{{ $t('screener.chatroom.user.chat.full.name.text') }}:</span> {{ userProfile.name }}</p>
                    <p><span>{{ $t('screener.chatroom.user.chat.bio.text') }}:</span> {{ userProfile.bio }} </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import defaultProfileImage from '@/assets/placeholder.jpg';

export default {
    name: 'UserProfileDrawer',
    props:{
        isOpen: {
            type:Boolean,
            default:false
        },
        userProfile : {
            type: Object,
            default:null
        }
    },
    computed:{
        profileImage() {
            return this.userProfile.profile_image || defaultProfileImage;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>